// extracted by mini-css-extract-plugin
export default {"button":"button_button__W4auM","light":"button_light__0TIh9","faded":"button_faded__pxU0w"};